// Lib
import React from 'react';
import { Typography } from '@mui/material';

// Components
import Layout from '../../../components/Layout';
import Spinner from '../../../components/Spinner';
import Feather from '../../../components/Feather';

// Hooks
import useSkipFromEmail from '../hooks/useSkipFromEmail';

// Styles
import { useStyles } from './SkipFromEmailStyles';

const SkipFromEmail = () => {
  const { loading, message, nextShipping, responseType } = useSkipFromEmail();
  const { classes, cx } = useStyles({
    isSuccessResponse: responseType === 'success',
  });

  return (
    <Layout hideHeaderLinks={true}>
      <div className={classes.container}>
        {loading ? (
          <Spinner />
        ) : (
          <>
            <div className={classes.icon}>
              <Feather nativeColor printType="stroke" type={responseType} />
            </div>
            <Typography textAlign="center" mt={3} variant="h2">
              {message}
            </Typography>
            {responseType === 'success' && (
              <span className={cx(classes.infoMessage, classes.centered)}>
                {`Recurring order is now updated. Next shipping: ${nextShipping}.`}
              </span>
            )}
          </>
        )}
      </div>
    </Layout>
  );
};

export default SkipFromEmail;
